module.exports = __webpack_public_path__ + "img/icon-payment-redpagos.b0da507d.png";